import React from 'react'
import { Typography, Stack, Box, Button, useTheme } from '@mui/material'
import { SectionLabel } from 'components/UI/SectionLabel'
import { CircleCheck } from 'lucide-react'
import { GoogleLoginButton } from 'components/GoogleLoginButton/GoogleLoginButton'
import { workosAuthService } from 'services/workos-auth.service'

interface ConnectedAccountsProps {
  isAccountLinked: boolean
}

export const ConnectedAccounts: React.FC<ConnectedAccountsProps> = ({ isAccountLinked }) => {
  const theme = useTheme()

  const handleAppleSignIn = () => {
    const embeddKey = sessionStorage.getItem('embeddKey')
    const companyId = sessionStorage.getItem('companyId')

    workosAuthService.loginWithApple({
      embeddKey: embeddKey || undefined,
      companyId: companyId || undefined,
    })
  }

  return (
    <Stack mb={4}>
      <SectionLabel>Connected accounts</SectionLabel>
      <Stack gap={1.5}>
        {isAccountLinked ? (
          <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1,
            px: 2, py: 1.25, borderRadius: `${theme.shape.borderRadius}px`,
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.background.paper,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
              <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width={18} height={18}>
                  <use xlinkHref={'#google'} />
                </svg>
              </Box>
              <Typography noWrap sx={{ color: theme.palette.text.primary, fontSize: '16px' }}>Connected with Google</Typography>
            </Box>
            <CircleCheck size={20} strokeWidth={1.5} color={(theme.palette as any).success?.main || '#2e7d32'} />
          </Box>
        ) : (
          <Box sx={{ mt: 0.5 }}>
            <GoogleLoginButton />
          </Box>
        )}

        <Button
          variant="outlined"
          onClick={handleAppleSignIn}
          sx={{
            justifyContent: 'flex-start', gap: 1.5, padding: '10px 16px',
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.grey[300],
            borderRadius: `${theme.shape.borderRadius}px`,
            textTransform: 'none',
            fontSize: '16px',
          }}
          fullWidth
        >
          <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
              <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"/>
            </svg>
          </Box>
          Connect with Apple
        </Button>
      </Stack>
    </Stack>
  )
}
